import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { AuthState } from "../store/slice/auth.slice";

export const useAuth = () => {
  return useSelector<RootState, AuthState>((state) => state.auth);
};

export const useIsAuthenticated = () => {
  return Boolean(localStorage.getItem("__Iplot_admin_access_"));
};
